<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="125" height="125" fill="none">
    <g stroke-linejoin="round" clip-path="url(#a)">
      <path
        stroke="#462170"
        stroke-linecap="round"
        stroke-width="1.3"
        d="m109.986 82.036-4.187-15.118a1.859 1.859 0 0 0-2.284-1.295l-27.649 7.613c-.411.73-1.337.99-2.067.578l-9.408 2.63a1.836 1.836 0 0 0-1.274 2.262l1.74 6.225a1.713 1.713 0 1 1 .922 3.3l1.74 6.226a1.836 1.836 0 0 0 2.262 1.274l9.408-2.629a1.518 1.518 0 0 1 2.068-.578l27.471-8.213a1.857 1.857 0 0 0 1.258-2.275Z"
      />
      <path
        stroke="#462170"
        stroke-dasharray="3 7"
        stroke-linecap="round"
        stroke-width="1.3"
        d="M79.812 91.403 75 74.183"
      />
      <path
        stroke="#462170"
        stroke-linecap="round"
        stroke-width="1.3"
        d="m66.301 75.91-1.91.533a1.835 1.835 0 0 0-1.274 2.263l1.74 6.225a1.713 1.713 0 1 1 .922 3.3l1.74 6.226a1.835 1.835 0 0 0 2.262 1.274M99.176 80.415a.455.455 0 0 1-.442-.155l-1.668-2.004-2.507-.742a.455.455 0 0 1-.25-.689l.631-.948a.456.456 0 0 1 .364-.203l1.798-.061.733-1.115-3.997-.808a.456.456 0 0 1-.292-.694l.766-1.18a.454.454 0 0 1 .368-.207l5.153-.16 1.239-1.89a1.41 1.41 0 0 1 .913-.613c.386-.08.76-.01 1.081.201a1.4 1.4 0 0 1 .612.908c.079.384.009.756-.202 1.077l-1.252 1.896 1.892 4.788a.458.458 0 0 1-.043.417l-.776 1.179a.455.455 0 0 1-.754.01l-2.328-3.351-.733 1.114.655 1.66a.452.452 0 0 1-.043.418l-.63.956a.456.456 0 0 1-.288.196ZM71.808 95.342v3.672M71.808 50.786v23.592M65.68 85.095v14.623M65.68 51.052v24.79M59.55 51.318v49.104M53.421 51.583v49.544"
      />
      <path
        fill="#462170"
        stroke="#462170"
        stroke-linecap="round"
        stroke-width="1.3"
        d="M31.941 114.188a3.714 3.714 0 1 0 0-7.428 3.714 3.714 0 0 0 0 7.428Z"
      />
      <path
        stroke="#462170"
        stroke-linecap="round"
        stroke-width="1.3"
        d="M54.525 27.419v14.998M44.664 27.419v14.998"
      />
      <path
        fill="#462170"
        stroke="#462170"
        stroke-linecap="round"
        stroke-width="1.3"
        d="M55.365 24.447H44.028c-.904 0-1.636.733-1.636 1.636v.69c0 .904.732 1.636 1.636 1.636h11.337c.904 0 1.636-.732 1.636-1.636v-.69c0-.903-.732-1.636-1.636-1.636Z"
      />
      <path
        stroke="#462170"
        stroke-linecap="round"
        stroke-width="1.3"
        d="M39.42 43.5c-6.017 0-10.895 4.877-10.895 10.894v44.68a9.581 9.581 0 0 0 8.774 9.547l4.224.357"
      />
      <path
        stroke="#462170"
        stroke-linecap="round"
        stroke-width="1.3"
        d="M39.42 43.5a16.457 16.457 0 0 0-5.386 12.313l.434 52.066M73.884 43.088c4.42.227 7.933 3.517 8.125 7.61l.234 9.653M83.015 92.21c-.972 12.682-6.205 17.465-27.258 17.854-18.667.346-13.76-13.268-13.945-51.287v-4.166c0-6.487 5.259-11.746 11.745-11.746h14.828M82.722 66.852c.028 1.529.065 3.01.104 4.441"
      />
      <path
        fill="#462170"
        stroke="#462170"
        stroke-linecap="round"
        stroke-width="1.3"
        d="M79.287 114.317a3.714 3.714 0 1 0 0-7.428 3.714 3.714 0 0 0 0 7.428ZM46.875 115.87a3.714 3.714 0 1 0 0-7.428 3.714 3.714 0 0 0 0 7.428Z"
      />
      <path
        stroke="#462170"
        stroke-linecap="round"
        stroke-width="2"
        d="M77.012 26.481c3.374 1.409 9.88 2.777 12.594 4.264 1.71 1.353 3.531 3.463 4.876 5.348 1.6 2.242 2.328 3.413 2.026 3.998-1.121 2.17-13.852-.861-23.054-4.737-4.53-1.908-20.795-9.717-19.842-13.176.307-1.115 2.645-2.119 11.517-1.654 2.967.884 8.51 4.548 11.883 5.957Z"
      />
      <path
        stroke="#462170"
        stroke-linecap="round"
        stroke-width="2"
        d="M89.565 30.976s3.047-9.002 2.59-9.625c-.458-.624-6.376-3.822-10.716-5.64-4.34-1.817-10.77-3.792-11.535-3.68-.765.11-5.035 8.601-5.035 8.601s3.99 3.684 11.632 6.885c7.64 3.2 13.064 3.46 13.064 3.46Z"
      />
      <path
        stroke="#462170"
        stroke-linecap="round"
        stroke-width="1.3"
        d="M92.201 21.866c-4.258-.337-7.504-1.743-11.853-3.606-2.407-1.148-4.728-2.48-6.988-3.949-1.13-.734-2.297-1.441-3.389-2.285"
      />
      <path
        stroke="#B1A8D3"
        stroke-width="5"
        d="M93.295 28.574s3.626-6.679 11.866-7.667c7.873-.947 12.501 3.405 12.551 3.874.05.469-11.076 10.736-24.417 3.793Z"
      />
      <path
        stroke="#B1A8D3"
        stroke-width="5"
        d="M91.473 30.982s1.94 7.869 9.632 11.466c7.35 3.434 12.803.508 12.96.053.157-.458-8.164-14.305-22.592-11.519ZM63.776 18.221c2.874 2.99 7.006 6.404 12.632 8.768 5.158 2.168 10.056 2.816 13.971 2.894"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h125v125H0z" /></clipPath>
    </defs>
  </svg>
</template>
